import React, { useState } from 'react';
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from 'react-responsive-carousel';
import { Button } from 'rsuite';
import { Link } from 'react-router-dom';

function DescriptionView(props) {
  let slides = [];
  // build slideList...
  if (props.selectedCruise.ship.image) {
    slides.push(
      <div key={props.selectedCruise.ship.id}>
        <img src={props.pictureserver + props.selectedCruise.ship.image} alt="Ship"
          onError={(e) => { e.target.onerror = null; e.target.src = "https://placeimg.com/240/100/nature?" + props.selectedCruise.ship.id }} />
        <p className="legend">{props.selectedCruise.ship.name}</p>
      </div>
      );
  }
  props.selectedCruise.stopPointsCruiseOnly.map((stoppoint) => {
    if (stoppoint.image) {
      slides.push(
        <div key={stoppoint.id} >
          <img src={props.pictureserver + stoppoint.image} alt="Stoppoint"
            onError={(e) => { e.target.onerror = null; e.target.src = "https://placeimg.com/240/100/nature?" + stoppoint.id }} />
          <p className="legend">{stoppoint.name}</p>
        </div>
      )
    }
  });

  const arrivalIndex = props.selectedCruise.stopPointsCruiseOnly.length - 1;

  // build description (first found in this order: cruise, destination-stoppoint, departure-stoppoint, nothing)...
  let description = props.selectedCruise.description
    ? { __html: props.selectedCruise.description }
    : props.selectedCruise.stopPointsCruiseOnly[arrivalIndex].description
      ? { __html: props.selectedCruise.stopPointsCruiseOnly[arrivalIndex].description }
      : props.selectedCruise.stopPointsCruiseOnly[0].description
        ? { __html: props.selectedCruise.stopPointsCruiseOnly[0].description }
        : null

  const [readMore, setReadMore] = useState(false);

  function handleReadMoreChange() {
    setReadMore(!readMore);
  }

  return (
    <div className={props.wrapperClass} >
      {slides.length > 0
        ?
        <Carousel autoPlay useKeyboardArrows infiniteLoop emulateTouch stopOnHover showThumbs={true}
          dynamicHeight={true} thumbWidth={10} className="md:w-1/2">
          {
            slides
          }
        </Carousel>
        : <h5 className="p-2 text-center">No images found</h5>
      }
      {/*
      <div className="absolute" style={{ right: 25, top: 45 }}>
        <Link to={"/details/" + props.token + "/" + props.selectedCruise.id} className="px-4 py-2 rounded bg-orange-500 text-white hover:bg-orange-600">
          See more
          </Link>
      </div>
      */}
      <div className="p-2">
        {description != null
          ? <React.Fragment>
            <div className={readMore ? "" : "overflow-hidden text-truncate-fade"} dangerouslySetInnerHTML={description}></div>
            <div className="text-right">
              <Button
                onClick={handleReadMoreChange}
                color="orange" size="xs" appearance="subtle">
                <p className="underline">{readMore ? "Collapse" : "Read more"}</p>
              </Button>
            </div>
          </React.Fragment>
          : null
        }
      </div>

      {props.showNavigation ?
        <div className="flex">
          <div className="p-4" >
            <Button
              onClick={props.handleMapViewChange}
              color="orange" size="xs" appearance="subtle">
              <p className="underline">See map</p>
            </Button>
          </div>
          <div className="p-4" >
            <Button
              onClick={props.handlePriceViewChange}
              color="orange" size="xs" appearance="subtle">
              <p className="underline">See prices</p>
            </Button>
          </div>
        </div>
        : null}
    </div>
  );
}

export default DescriptionView;